import { useScrollRestoration } from "@/hooks/useScrollRestoration";

export const ScrollRestoration = () => {
  useScrollRestoration();
  return null;
};
